import { PhCalendar } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type WebsiteResource,
  type ReservationEmbedSection,
  type ReservationEmbedSectionCreate,
  type ReservationEmbedSectionUpdate,
} from '../../WebsiteBuilder.types'
import { websiteBlockMethods } from '../common/methods'

import ReservationEmbedEditor from './editor/ReservationEmbedEditor.vue'
import { createReservationEmbedData } from './methods/createReservationEmbedData'
import ReservationEmbedPreview from './preview/ReservationEmbedPreview.vue'

const i18n = i18nPlugin.global

export const ReservationEmbedBlockModule: BuilderBlockModule<
  ReservationEmbedSection,
  ReservationEmbedSectionCreate,
  ReservationEmbedSectionUpdate,
  WebsiteResource
> = {
  createData: createReservationEmbedData,
  editor: ReservationEmbedEditor,
  meta: [
    {
      icon: PhCalendar,
      key: 'reservation-embed',
      label: i18n.t('website-builder.blocks.reservation-embed'),
    },
  ],
  methods: websiteBlockMethods,
  preview: ReservationEmbedPreview,
}
